let tablist = {
    code: 200,
    message: 'success',
    'time1': [
        {
            "id": "5406616",
            "name": 'Skimlinks',
            "url": "http://skimlinks.com/",
            "oderunm": "23",
            "je": "27352",
            "pt": 0,
            "type": "Sub-Aff",
            "ordersum": "2118053,2117453,2117213,2116483,2115463,2113923,2113883,2112873,2112683,2109933,2109803,2109583,2109283,2107683,2107513,2103673,2102803,2102703,2102603,2101713,291563,285313,2123083",
        },
        {
            "id": "5412276",
            "name": 'Sovrn',
            "url": "https://sovrn.com/commerce/",
            "oderunm": "1",
            "je": "999",
            "pt": 0,
            "type": "Sub-Aff",
            "ordersum": "295503",
        },
        {
            "id": "51328936",
            "name": 'FlexOffers.com',
            "url": "http://www.flexoffers.com",
            "oderunm": "48",
            "je": "64876.2",
            "pt": 0,
            "type": "Sub-Aff",
            "ordersum": "2121913,2119763,2119183,2117843,2117343,2116953,2115723,2113213,2112243,2111133,2111043,2110633,2109043,2108423,2106933,2105833,2103693,2103663,299773,296953,295843,293343,292903,291933,291853,290953,290223,289473,289063,288473,288253,288203,288013,287833,287783,287753,287063,286403,285173,2125913,2124963,2124933,2124823,2124543,2124353,2124103,2123633,2122993",
        }, {
            "id": "51349456",
            "name": 'Capital One Shopping',
            "url": "https://capitaloneshopping.com/",
            "oderunm": "26",
            "je": "29246.8",
            "pt": 1,
            "type": "Cash-Back",
            "ordersum": "2122093,2121793,2120733,2120053,2119493,2117763,2116473,2116053,2115993,2115273,2113843,2111733,2111563,2111473,2105263,2104293,2100023,298503,295913,295553,292063,288093,287663,2125403,2124913,2124123",
        },

    ],
}

export default {
    'post|/tabLIST': tablist,
    // 'post/'
}